import React from 'react';
import { Container } from 'reactstrap';
import { DashboardPageHeader, ComingSoonCard, DeptModulesGrid } from '../../Components/Common/DashboardKit';

/**
 * Production module landing page.
 *
 * Owner (2026-10-05): the department pages show MODULES, one card per module, the same
 * cards as General SS White (DeptLandingSections); a card shows only when the person may
 * open it. The Reports & KPI card opens the KPI hub on this department's tab.
 * The route is gated by dept.production in allRoutes.js.
 */
const MODULES = ["display", "di", "app-mafia", "tasks", "time", "dms", "epo", "app-tooltracker", "kpi"];

const Production = () => {
    document.title = "SSW Technologies Dashboard";

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <DashboardPageHeader
                        icon="ri-tools-line"
                        eyebrow="Shop Floor"
                        title="Production"
                        subtitle="Shop floor activity and run-rate insights"
                        tone="teal"
                        breadcrumb={[
                            { label: "Dashboards", to: "/" },
                            { label: "Production" },
                        ]}
                    />

                    <DeptModulesGrid ids={MODULES} dept="production" title="Production modules" icon="ri-tools-line" />

                    <ComingSoonCard
                        compact
                        icon="ri-tools-line"
                        title="More for Production later"
                        message="Ideas for later: hourly run-rate by machine, downtime causes and shift summaries. The modules above are live today."
                        tone="success"
                    />
                </Container>
            </div>
        </React.Fragment>
    );
};

export default Production;
